import { render, staticRenderFns } from "./UpdatePlatformDialog.vue?vue&type=template&id=5cea570d&scoped=true&lang=pug&"
import script from "./UpdatePlatformDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdatePlatformDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cea570d",
  null
  
)

export default component.exports